// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"PixelsInput__wrapper___3fqQe","controls":"PixelsInput__controls___SNn_c","controlsItem":"PixelsInput__controlsItem___29JOi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/PixelsInput/PixelsInput.scss
// module id = 999
// module chunks = 0